export default "__VITE_ASSET__BITBz1yQ__"